
<template>
  <base-modal :title="title" :width="width" :visible="visible" @cancel="open(false)">
    <div slot="modalBody">
      <a-form :form="form" @submit="handleSubmit">
        <a-row>
          <a-col :span="colSpan">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="编号"
              hasFeedback
            >
              <a-input
                placeholder="请输入编号"
                id="id"
                autocomplete="off"
                :allowClear="true"
                :disabled="!isEdit"
                v-model="model.id"/>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="试卷名称"
              hasFeedback
            >
              <a-input
                placeholder="请输入试卷名称"
                id="name"
                autocomplete="off"
                :allowClear="true"
                :disabled="!isEdit"
                v-model="model.name"/>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="试卷答案"
              hasFeedback
            >
              <a-input
                placeholder="请输入试卷答案"
                id="nameWithAnswer"
                autocomplete="off"
                :allowClear="true"
                :disabled="!isEdit"
                v-model="model.nameWithAnswer"/>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="生成时间"
              hasFeedback
            >
              <a-date-picker :disabled="!isEdit" style="width:100%" placeholder="请选择生成时间" v-model="model.createTime"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :wrapper-col="{ span: 12, offset: 5 }" v-if="isEdit">
              <a-button type="primary" html-type="submit" style="margin-right:10px;">
                提交
              </a-button>
              <a-button style="margin-right:10px;" @click="cancel">
                取消
              </a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </base-modal>
</template>

<script>
import baseModal from '@/CrComponents/Modal/Modal.vue'
import { mapState } from 'vuex'

import { insertPaper, updatePaper } from '@/api/paper'
export default {
  name: 'EditPaper',
  mounted () {

  },
  computed: {
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    ...mapState({

    })
  },
  components: {
    baseModal

  },
  data () {
    return {
      title: '操作',
      width: 1000,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'paper' }),
      visible: false,
      defaultModel: {},
      model: {

        id: '',
        name: '',
        nameWithAnswer: '',
        createTime: ''
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 21 }
      },
      colSpan: 12

    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      if ((this.type === this.$sysInfo.MODAL_MODIFY) || (this.type === this.$sysInfo.MODAL_VIEW)) {
        if (flag) {
          this.$nextTick(() => {

          })
          // this.getModelInfo(this.model) 通过接口获取详情
        }
      }
    },
    // 提交表单
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          const params = { ...this.model, ...value }
          if (this.type === this.$sysInfo.MODAL_ADD) {
            delete params.id
            insertPaper(params).then(res => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('refreshTable')
                this.open(false)
              } else {
                this.$message.error(res.info.message)
              }
            })
          } else if (this.type === this.$sysInfo.MODAL_MODIFY) {
            updatePaper(params).then(res => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('refreshTable')
                this.open(false)
              } else {
                this.$message.error(res.info.message)
              }
            })
          }
        }
      })
    },
    // 获取当前的model详情

    handleChange () {

    },
    // 清空表单
    formClear () {
      this.$nextTick(() => {
        this.model.id = ''
        this.model.name = ''
        this.model.nameWithAnswer = ''
        this.model.createTime = null
      })
    },
    cancel () {
      this.formClear()
      this.open(false)
    }
    // 获取select列表

  }
}
</script>

<style scoped lang="less">

</style>
